import { Box, Divider, Grid } from "@mui/material";
import { action, API, controller } from "api";
import { Button, Input } from "controls";
import { Model, ToFormData, UseForm } from "hooks";
import { Form } from "layout";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import FeaturePermissionForm from "./AccessFields/FeaturePermissionForm";

const AddEditRole = ({ setShowForm, updData, setRefreshKey }) => {
  const { UserRoleMdl } = Model();
  const [featureAccess, setFeatureAccess] = useState({});

  const [loading, setLoading] = useState(false);
  const { values, setValues, errors, setErrors, handleInpChg } =
    UseForm(UserRoleMdl);

  const validateForm = () => {
    let temp = {};
    temp.title = values.title !== "" ? "" : "Title is required";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  useEffect(() => {
    if (updData && updData.id) {
      API(controller.UserRole + action.GetById).getById(updData.id, (res) => {
        var val = res.result;
        if (val && val.id) {
          setValues({ ...val });
          setFeatureAccess({ ...val.featureAccess });
        } else toast.error(res?.msg);
      });
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setRefreshKey((prev) => prev + 1);
        setLoading(false);
        setShowForm(false);
        // Alert
        res?.status === 200 && res.msg
          ? toast.success(res.msg)
          : toast.error(res.msg);
      };

      if (updData && updData.id) {
        API(controller.UserRole + action.Put).put(
          ToFormData({
            ...values,
            featureAccess,
          }),
          onComplete
        );
      } else {
        API(controller.UserRole + action.Post).post(
          ToFormData({
            ...values,
            featureAccess,
          }),
          onComplete
        );
      }
    }
  };

  return (
    <Form noValidate onSubmit={handleSubmit}>
      <div className="flex flex-wrap justify-between items-center p-[5px] gap-2">
        <div>
          <span className="border-left text-[18px] ml-[5px] uppercase text-gray-500 font-medium">
            {updData?.id ? "Update" : "Create"} Role
          </span>
        </div>
        <Box className="flex gap-2" sx={{ width: { xs: "100%", md: "auto" } }}>
          <Button
            onClick={() => setShowForm(false)}
            sx={{ width: { xs: "100%", md: "auto" } }}
            variant="text"
          >
            Close
          </Button>
          <Button
            type="submit"
            loading={loading}
            sx={{ width: { xs: "100%", md: "auto" } }}
          >
            {!updData ? "Submit" : "Save Changes"}
          </Button>
        </Box>
      </div>
      <Divider className="!mb-[10px]" />
      <Grid container spacing={2} className="p-[10px]">
        <Grid item xs={12} md={6}>
          <Input
            required
            size="small"
            label="Title"
            name="title"
            value={values.title}
            error={errors.title}
            onChange={handleInpChg}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Input
            size="small"
            label="Subtitle"
            name="subtitle"
            value={values.subtitle}
            onChange={handleInpChg}
            fullWidth
          />
        </Grid>
      </Grid>
      <div className="mt-[10px]">
        <span className="border-left uppercase font-medium text-[14px] text-gray-500 ml-[10px]">
          Define Access for this Role
        </span>
        <Divider className="!mt-[5px]" />
        <FeaturePermissionForm
          values={featureAccess}
          setValues={setFeatureAccess}
        />
      </div>
    </Form>
  );
};

export default AddEditRole;
